import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { computed, observable, action } from 'mobx';
import { task } from 'mobx-task';
import groupBy from 'lodash/groupBy';
import { formatDateSimple } from '../utils/dateUtil';
var TransactionLogViewState = (_dec = action.bound, _dec2 = action.bound, _class = /*#__PURE__*/function (_Store) {
  function TransactionLogViewState(_ref) {
    var _this;
    var rootStore = _ref.rootStore;
    _classCallCheck(this, TransactionLogViewState);
    _this = _callSuper(this, TransactionLogViewState, arguments);
    _initializerDefineProperty(_this, "view", _descriptor, _this);
    _initializerDefineProperty(_this, "billingMethodId", _descriptor2, _this);
    _this.rootStore = rootStore;
    return _this;
  }
  _inherits(TransactionLogViewState, _Store);
  return _createClass(TransactionLogViewState, [{
    key: "transactions",
    get: function get() {
      return this.rootStore.billingStore.transactionsForBillingMethod(this.billingMethodId);
    }
  }, {
    key: "busy",
    get: function get() {
      return this.rootStore.billingStore.getTransactionsForBillingMethod.pending;
    }
  }, {
    key: "csvData",
    get: function get() {
      // i personally find these fields very weird by this is what the CS Team **cough**Kristal**cough** wants
      var data = [['Job ID', 'Job Name', 'Team Name', 'Pro Name', 'Closed Date', 'Total']];
      data.push.apply(data, _toConsumableArray(this.groupedTransactions.filter(function (x) {
        return Array.isArray(x);
      }).map(function (transactions) {
        var t = transactions[0];
        var pro = t.job.members.find(function (m) {
          return m.role === 'CHAMPION' && m.type === 'PROVIDER';
        }) || {
          user: {}
        };
        return [t.job.id, t.job.name || t.job.description, t.team ? t.team.name : '', pro.user.displayName, formatDateSimple(t.job.dateClosed), t.job.total];
      })));
      return data;
    }

    /**
     * Grouped transactions are grouped if they have a job.
     * Otherwise they are still the regular ones.
     *
     * Therefore the result object is something like:
     * [
     *  transaction,
     *  transaction,
     *  Array<transaction>
     * ]
     */
  }, {
    key: "groupedTransactions",
    get: function get() {
      var result = [];
      var allTransactions = this.transactions;
      // first add all the ones we dont need to group
      result.push.apply(result, _toConsumableArray(allTransactions.filter(function (x) {
        return !x.job;
      })));

      // now let group transactions by job
      var temp = groupBy(allTransactions.filter(function (x) {
        return x.job;
      }), function (x) {
        return x.job.id;
      });
      result.push.apply(result, _toConsumableArray(Object.values(temp)));
      result.sort(function (a, b) {
        if (Array.isArray(a)) {
          a = a.reduce(function (x, y) {
            return x.id > y.id ? x : y;
          });
        }
        if (Array.isArray(b)) {
          b = b.reduce(function (x, y) {
            return x.id > y.id ? x : y;
          });
        }
        return b.id - a.id;
      });
      return result;
    }
  }, {
    key: "showGroupedView",
    value: function showGroupedView() {
      this.view = 'grouped';
    }
  }, {
    key: "showListView",
    value: function showListView() {
      this.view = 'list';
    }
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var opts,
          _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              if (!opts.billingMethodId) {
                _context.next = 4;
                break;
              }
              this.billingMethodId = opts.billingMethodId;
              return _context.abrupt("return", this.rootStore.billingStore.getTransactionsForBillingMethod(this.billingMethodId));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "view", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'grouped';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "billingMethodId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return -1;
  }
}), _applyDecoratedDescriptor(_class.prototype, "transactions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "transactions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "busy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "busy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "csvData", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "csvData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupedTransactions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupedTransactions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showGroupedView", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "showGroupedView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showListView", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "showListView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [task], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _class);
export { TransactionLogViewState as default };
//# sourceMappingURL=TransactionLogViewState.js.map
